import { render } from "./PriceTableAdmin.vue?vue&type=template&id=60b2e833&scoped=true"
import script from "./PriceTableAdmin.vue?vue&type=script&lang=js"
export * from "./PriceTableAdmin.vue?vue&type=script&lang=js"

import "./PriceTableAdmin.vue?vue&type=style&index=0&id=60b2e833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b2e833"]])

export default __exports__